// src/shared/hooks/useService.js
import { useMemo } from 'react';
import ServiceFactory from '../services/ServiceFactory';

export const useService = () => {
    return useMemo(() => ServiceFactory.getService(), []);
};
